import { ApiClient } from '@/infra/api-client'
import Env from '@/infra/env'
import { NEVER } from 'rxjs'

/**
 * API for email confirmation.
 */
export class EmailConfirmationApi extends ApiClient {
  constructor() {
    super({
      token$: NEVER,
      baseURL: Env.IAM_API,
    })
  }

  /**
   * Queries for the verification status of a user.
   */
  getVerificationStatus(token: string): Promise<boolean> {
    return this._get<{ verified: boolean }>(
      'v1/email-verification/status',
      undefined,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    ).then((o) => o.verified)
  }

  /**
   * Resends the verification email.
   */
  async resendEmail(token: string) {
    const request = new Request(
      new URL('v1/email-verification/resend', this.options.baseURL),
      { method: 'POST', headers: { Authorization: `Bearer ${token}` } },
    )

    await this._send(request).then(ApiClient.throwIfNotSuccessful)
  }
}
